import React, { useEffect, useRef, useState } from "react";
import "../App.css";
import IconButton from "@material-ui/core/IconButton";
import SendIcon from "@mui/icons-material/Send";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import UserImage from "../assets/user.png";
import sendImage from "../assets/send.png";
import imageImage from "../assets/image.png";

interface Message {
  username: string;
  text?: string;
  image?: string;
}

interface Props {
  w_id: string | null;
}

export interface receivedMessage {
  chatid: string;
  createdAt: string;
  dbtime: string;
  image_slist: string | undefined;
  incidentid: string;
  text: string;
  userId: string;
  username: string;
}

const PopUpWindowChat: React.FC<Props> = ({ w_id }) => {
  const base_url = "https://mobile.mobilise-project.org.uk/mobisense";

  const chatRef = useRef<HTMLDivElement>(null);
  const [inputImage, setInputImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [receivedMessage, setReceivedMessage] = useState<receivedMessage[]>([]);
  const [messages, setMessages] = useState<Message[]>([
    { username: "Alice", text: "Hi there!" },
    { username: "Bob", text: "Hey, how are you?" },
    { username: "Alice", text: "I'm good, thanks!" },
    { username: "Bob", text: "Great to hear!" },
  ]);
  const [commentImage, setCommentImage] = useState<File | null>(null)
  const [commentMessage, setCommentMessage] = useState<string>('')

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollIntoView();
    }
  }, [imagePreview, receivedMessage]);

  const fetchData = async () => {
    if (!w_id) {
      return;
    }

    try {
      const currentDate = new Date();
      const formattedCurrentDate = currentDate.toISOString().replace("Z", "");

      const url = new URL(
        "https://mobile.mobilise-project.org.uk/mobisense/receivedMessages"
      );
      url.searchParams.append("incidentid", w_id);
      url.searchParams.append("dbtime", "2024-05-27 17:02:36.615");

      const response = await fetch(url.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const responseData = await response.json();
      if (Array.isArray(responseData)) {
        const data: receivedMessage[] = responseData;
        setReceivedMessage(data);
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [w_id]);

  const handleSend = () => {
    if (commentMessage.trim() !== "" || commentImage) {
      const newMessage: Message = {
        username: "You",
        text: commentMessage.trim(),
        image: commentImage ? URL.createObjectURL(commentImage) : undefined,
      };
      setMessages((prevMessages) => [...prevMessages, newMessage]);
      setCommentMessage("");
      setCommentImage(prevData => null);
    }
  };


  // Handel image load
  const handleImageLoad = () => {
      if(commentImage)
      {
          setCommentImage(prevData => null)
      }
      else
      {
          const imageInput = document.createElement('input')
          imageInput.type = 'file'
          imageInput.accept = 'image/*'
  
          imageInput.onchange = (event: Event) => {
              const target = event.target as HTMLInputElement
              const file = target.files?.[0]
              if(file)
              {
                  setCommentImage(file)
              }
          }
          imageInput.click()
      }
  }



  return (
    <>
      <div className="commentBox">
        {receivedMessage.map((message, index) => (
          <div className="comment">
            <div className="userPic"></div>
            {
                   message.username === "You" ? (
                    <div className="messageContainer">
                       <span className='username'>{message.username}</span>
                    {message.text && <span className="message">{message.text}</span>}
      
                    {message.image_slist && message.image_slist !== "" && (
                      <img src={base_url + message.image_slist} alt="" />
                    )}
      
                    {/* {comment.image === '' ? null : <img src={comment.image} alt="" />} */}
                    <span className="time">{message.createdAt}</span>
                  </div>
                   ):(
                    <div className="messageContainer">
                        <span className='username'>{message.username}</span>
                    {message.text && <span className="message">{message.text}</span>}
      
                    {message.image_slist && message.image_slist !== "" && (
                      <img src={base_url + message.image_slist} alt="" />
                    )}
      
                    {/* {comment.image === '' ? null : <img src={comment.image} alt="" />} */}
                    <span className="time">{message.createdAt}</span>
                  </div>
                  ) }
    
          </div>
        ))}
      </div>
      {/* Send box */}
      <div className='sendBox'>
                                {commentImage && (
                                    <div className='imagePreviewContainer'>
                                        <img src={URL.createObjectURL(commentImage)} alt="" />
                                    </div>
                                )}
                                <input type="text" name="" id="" placeholder='Enter comment' onChange={(e) => setCommentMessage(prevData => e.target.value)}/>
                                <button className='image' onClick={(e) => handleImageLoad()}  onTouchStart={(e) => handleImageLoad()}>
                                    <div className={`${commentImage !== null ? 'remove' : 'add'}`} />
                                </button>
                                <button className='send' onClick={(e) =>handleSend()}  onTouchStart={(e) =>handleSend()} disabled={commentMessage || commentImage ? false : true}></button>
                            </div>
    </>  
  );
};

export default PopUpWindowChat;
